// import './test';

// -------------------------------------------------------------------< constants >-------------------------------------------------------------------

// ******************************************************************* positions *********************************************************************
const INDEX_POSITIONS_SUCCESS = "INDEX_POSITIONS_SUCCESS";
const SHOW_POSITION_SUCCESS = "SHOW_POSITION_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ******************************************************************** positions ********************************************************************
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexPositionsSuccess(payload) {
  return {
    type: INDEX_POSITIONS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showPositionSuccess(payload) {
  return {
    type: SHOW_POSITION_SUCCESS,
    payload: payload.data,
  };
}

// ******************************************************************** positions ********************************************************************
/**
 *
 * @param {Function} callback
 * @param {Object} [params={}]
 * @return {Function}
 */
export function indexPositions(params = {}, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    // Default routes
    let routes = "/positions";
    let _params = params;
    let include = [
      "user:id,active",
      "user.profile:id,user_id,first_name,last_name,personnel_id",
    ];

    api
      .get(routes, {
        params: Object.assign({}, { includes: include }, _params),
      })
      .then((res) => {
        dispatch(_indexPositionsSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.basic.organization-chart",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(
            "routes.home.basic.organization-chart.Indexing Positions Failed"
          )
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {number} id
 * @param {Function} callback
 * @return {Function}
 */
export function showPosition(id, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Position@index")) {
      api
        .get(`/positions/${id}`, {
          params: {
            includes: ["user", "user.profile"],
          },
        })
        .then((res) => {
          dispatch(_showPositionSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.basic.organization-chart",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate(
              "routes.home.basic.organization-chart.Showing Positions Failed"
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @return {Function}
 */
export function emptyPosition() {
  return _showPositionSuccess({ data: { position: {} } });
}

/**
 *
 * @return {Function}
 */
export function emptyPositions() {
  return _indexPositionsSuccess({ data: { positions: [] } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------

/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    positions: [],
    pagination: {},
    positionsMeta: [],
    position: {},
  },
  action
) {
  let positions = app._.cloneDeep(state.positions);
  let _index;

  switch (action.type) {
    case INDEX_POSITIONS_SUCCESS:
      let meta = action.payload.meta;
      return Object.assign({}, state, {
        positions: action.payload.data.positions,
        pagination: meta
          ? app.pagination(meta.currentPage + 1, meta.total, meta.limit)
          : {},
        positionsMeta: meta,
      });
    case SHOW_POSITION_SUCCESS:
      return Object.assign({}, state, {
        position: action.payload.position,
      });
    default:
      return state;
  }
}
